var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import cxs from 'cxs/component';
import classNames from 'classnames';
var SaleTicketCheckin = /** @class */ (function (_super) {
    __extends(SaleTicketCheckin, _super);
    function SaleTicketCheckin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleTicketCheckin.prototype.render = function () {
        var _a = this.props, salesChart = _a.salesChart, ticketsChart = _a.ticketsChart, checkinsChart = _a.checkinsChart, cardChartOpts = _a.cardChartOpts, title = _a.title, subtitle = _a.subtitle, one = _a.one, charToShow = _a.charToShow;
        // console.log('ticketsChart', charToShow)
        var prueba = [
            { name: 'excursiones', valor: { adulto: 51, nigno: 15, bebe: 5 } }, { name: 'linea regular', valor: { adulto: 3, nigno: 1, bebe: 2 } },
        ];
        return (React.createElement(Row, { className: "mr-1 ml-1 justify-content-center" },
            React.createElement("div", { className: classNames('col-12') },
                React.createElement(Card, null,
                    React.createElement(CardBody, null,
                        React.createElement(Row, null,
                            React.createElement("div", { className: "col-12" },
                                React.createElement(CardTitle, { className: "mb-0" }, subtitle),
                                React.createElement("div", { className: "small text-muted" }, title))),
                        charToShow.has('sales') && React.createElement(Row, null,
                            React.createElement(Col, null,
                                React.createElement(Styled, null,
                                    React.createElement("div", { style: styleChartF(salesChart.labels.length, innerWidth) },
                                        React.createElement(Bar, { data: salesChart, options: cardChartOpts, height: 300 }))))),
                        charToShow.has('checkins') && React.createElement(Row, null,
                            React.createElement("div", { className: "col-12" },
                                React.createElement(Styled, null,
                                    React.createElement("div", { style: styleChartF(checkinsChart.labels.length, innerWidth) },
                                        React.createElement(Bar, { data: checkinsChart, options: cardChartOpts }))))),
                        charToShow.has('tickets') && React.createElement(Row, null,
                            React.createElement(Col, null,
                                React.createElement(Styled, null,
                                    React.createElement("div", { style: styleChartF(ticketsChart.labels.length, innerWidth) },
                                        React.createElement(Bar, { data: ticketsChart, options: cardChartOpts, height: 300 }))))))))));
    };
    return SaleTicketCheckin;
}(Component));
export default SaleTicketCheckin;
var styleChartF = function (numero, innerWidth) {
    // console.error('numero', numero)
    // console.error('innerWidth', innerWidth)
    var result;
    var factor = 24;
    if (innerWidth < 768) {
        factor = 8;
    } /* else if (innerWidth < 992) {
      factor = 24
    } else if (innerWidth < 1200) {
      factor = 32
    }*/
    // console.error('factor', factor)
    if (numero > factor) {
        result = (Math.trunc(numero * 1000 / 42)) + 'px';
    }
    else {
        result = '100%';
    }
    // console.error('result', result)
    // console.log('*********************************************************')
    return {
        height: '340px',
        marginTop: '20px',
        overflowX: 'auto',
        paddingTop: '0px',
        width: result,
        background: 'rgba(161,159,161,0.02)'
    };
};
var Styled = cxs('div')({ overflow: 'auto' });



//////////////////
// WEBPACK FOOTER
// ./src/components/SaleTicketCheckin.tsx
// module id = 1056
// module chunks = 0